// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"e9ce4c85","453":"f4feb12f","837":"7b4d0f17"}[chunkId] + ".chunk.js";
};